export const smallMobile = 500
export const mobile = 600
export const tablet = 768
export const desktop = 956
export const bigDesktop = 1080
export const largeDesktop = 1200
